var OfferingCategoryDtoBuilder = /** @class */ (function () {
    function OfferingCategoryDtoBuilder() {
        this.category = {
            id: 'category-id',
            name: '',
            order: 0,
        };
    }
    OfferingCategoryDtoBuilder.prototype.withCategoryId = function (id) {
        this.category.id = id;
        return this;
    };
    OfferingCategoryDtoBuilder.prototype.withName = function (name) {
        this.category.name = name;
        return this;
    };
    OfferingCategoryDtoBuilder.prototype.withUrlName = function (urlName) {
        this.category.urlName = urlName;
        return this;
    };
    OfferingCategoryDtoBuilder.prototype.withOrder = function (order) {
        this.category.order = order;
        return this;
    };
    OfferingCategoryDtoBuilder.prototype.build = function () {
        return this.category;
    };
    return OfferingCategoryDtoBuilder;
}());
export { OfferingCategoryDtoBuilder };
//# sourceMappingURL=category.dto.builder.js.map